(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["henvo-product-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('henvo-product-menu')) {
    let henvoMenuSequence = 0;
    class HenvoProductMenu extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        if (!this.trigger || !this.panel) return;
        this.mobile = this.dataset.placement === 'mobile';
        this.panel.id = 'henvo-products-panel-' + ++henvoMenuSequence;
        this.trigger.setAttribute('aria-controls', this.panel.id);
        if (!this.mobile && typeof this.panel.showPopover === 'function') this.panel.setAttribute('popover', 'manual');
        this.close();
        this.addEventListener('click', (event) => {
          if (!event.target.closest('[data-henvo-trigger]')) return;
          if (this.expanded && (!this.hoverOpened || event.detail === 0)) this.close();
          else { this.open(); this.hoverOpened = false; }
        }, options);
        this.addEventListener('pointerenter', (event) => {
          clearTimeout(this.timer);
          if (!this.mobile && event.pointerType === 'mouse' && !this.expanded) { this.open(); this.hoverOpened = true; }
        }, options);
        this.addEventListener('pointerleave', (event) => {
          this.scheduleClose(event);
        }, options);
        this.panel.addEventListener('pointerenter', () => clearTimeout(this.timer), options);
        this.panel.addEventListener('pointerleave', (event) => this.scheduleClose(event), options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.expanded) {
            event.preventDefault(); event.stopPropagation(); this.close(); this.trigger.focus();
          } else if (event.target === this.trigger && event.key === 'ArrowDown') {
            event.preventDefault(); event.stopPropagation(); this.open(); this.panel.querySelector('a')?.focus();
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
        this.addEventListener('click', (event) => {
          const link = event.target.closest('.henvo-menu__item');
          if (!link) return;
          const target = link.dataset.henvoCategory;
          if (target) {
            const tab = document.querySelector('[data-pct-block-id="' + CSS.escape(target) + '"]');
            if (tab) {
              event.preventDefault();
              tab.click();
              history.replaceState(null, '', link.href);
              requestAnimationFrame(() => document.getElementById('henvo-products')?.scrollIntoView({ block: 'start' }));
            }
          }
          this.close();
        }, options);
        window.addEventListener('resize', () => this.close(), options);
        window.addEventListener('scroll', () => { if (this.expanded && !this.mobile) this.syncPosition(); }, options);
        const drawer = this.closest('details.menu-drawer-container');
        drawer?.addEventListener('toggle', () => { if (!drawer.open) this.close(); }, options);
      }
      disconnectedCallback() { this.events?.abort(); clearTimeout(this.timer); if (this.panel?.matches(':popover-open')) this.panel.hidePopover(); }
      get trigger() { return this.querySelector('[data-henvo-trigger]'); }
      get panel() { return this.querySelector('[data-henvo-panel]'); }
      get expanded() { return this.trigger?.getAttribute('aria-expanded') === 'true'; }
      scheduleClose(event) {
        if (this.mobile || event.pointerType !== 'mouse' || !this.hoverOpened || this.contains(event.relatedTarget)) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (!this.hoverOpened || this.panel.matches(':hover') || this.trigger.matches(':hover')) return;
          const focused = document.activeElement;
          if (focused !== this.trigger && this.contains(focused)) return;
          this.close();
        }, 450);
      }
      syncPosition() {
        const rect = this.trigger.getBoundingClientRect();
        if (rect.bottom < 1 || rect.top >= window.innerHeight) { this.close(); return; }
        const top = Math.ceil(rect.bottom);
        const width = Math.min(680, window.innerWidth - 32);
        const left = Math.max(16, Math.min(rect.left, window.innerWidth - width - 16));
        this.panel.style.setProperty('--henvo-menu-top', top + 'px');
        this.panel.style.setProperty('--henvo-menu-left', Math.round(left) + 'px');
        this.panel.style.setProperty('--henvo-menu-height', Math.max(100, window.innerHeight - top - 16) + 'px');
      }
      open() {
        if (!this.isConnected || !this.trigger || !this.panel) return;
        clearTimeout(this.timer);
        document.querySelectorAll('henvo-product-menu').forEach(menu => { if (menu !== this && typeof menu.close === 'function') menu.close(); });
        this.trigger.setAttribute('aria-controls', this.panel.id);
        if (!this.mobile && typeof this.panel.showPopover === 'function') this.panel.setAttribute('popover', 'manual');
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
        if (!this.mobile) {
          this.syncPosition();
          if (this.panel.hasAttribute('popover') && !this.panel.matches(':popover-open')) this.panel.showPopover();
        }
      }
      close() {
        clearTimeout(this.timer);
        this.hoverOpened = false;
        if (this.panel?.matches(':popover-open')) this.panel.hidePopover();
        if (this.panel) this.panel.hidden = true;
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
      }
    }
    customElements.define('henvo-product-menu', HenvoProductMenu);
    const selectHenvoCategory = () => {
      const category = new URLSearchParams(location.search).get('pump_category');
      if (!category) return;
      const tab = document.querySelector('[data-pct-block-id="' + CSS.escape(category) + '"]');
      if (tab) { tab.click(); document.getElementById('henvo-products')?.scrollIntoView({ block: 'start' }); }
    };
    if (document.readyState === 'complete') selectHenvoCategory();
    else window.addEventListener('load', selectHenvoCategory, { once: true });
    window.addEventListener('popstate', selectHenvoCategory);
  }
  } catch(e) { console.error(e); }
})();

})();
